import {atom} from 'recoil';

export default atom<string>({
  key: 'selectCompanyPreleadProjectAtom',
  default: null,
});
